<template>
    <div id="w_settings">
        <Settings></Settings>
    </div>
</template>

<script>
    import Settings from '../../components/security/Settings'

    export default{
        name: 'w_settings',
        components: {
            Settings
        }
    }
</script>
